import { Component, Input, OnInit } from '@angular/core';
import { COMMON_IMPORTS } from '../common-imports';
import {
  AxialLengthType,
  EyeSideValues,
  GraphDataEthnicity,
  PercentileQualifier,
  PredictedAt18Qualifier,
  SERValueType,
} from '../backend-response-models/calc-enums.helper';
import { SerPercentileComponent } from '../ser-stats/ser-percentile/ser-percentile.component';
import { AxialCalcResponse, CalculationResults, SerCalcResponse } from '../backend-response-models/calc-interfaces.helper';
import { AxialPercentileComponent } from '../axial-stats/axial-percentile/axial-percentile.component';
import { FutureMyopiaComponent } from './future-myopia/future-myopia.component';
import { MyopiaSingleEimRetestComponent } from './myopia-single-eim-retest/myopia-single-eim-retest.component';
import { PopulationComparisonComponent } from '../population-comparison/population-comparison.component';
import { CreditsComponent } from '../credits/credits.component';
import { ReportType } from '../shared/shared-enums/shared.enums';
import { ParentParagraphComponent, ParentParagraphType } from '../parent-paragraph/parent-paragraph.component';
import { MyopiaTreatmentsComponent } from '../myopia-treatments/myopia-treatments.component';
import { StandardProgressionComponent } from '../standard-progression/standard-progression.component';
import { PatientInfoInputComponent } from '../patient-info-input/patient-info-input.component';

@Component({
  selector: 'app-myopia-single-dashboard',
  standalone: true,
  imports: [
    SerPercentileComponent,
    AxialPercentileComponent,
    StandardProgressionComponent,
    CreditsComponent,
    FutureMyopiaComponent,
    PopulationComparisonComponent,
    ParentParagraphComponent,
    ...COMMON_IMPORTS,
    MyopiaTreatmentsComponent,
    PatientInfoInputComponent,
  ],
  templateUrl: './myopia-single-dashboard.component.html',
  styleUrl: './myopia-single-dashboard.component.css',
})
export class MyopiaSingleDashboardComponent implements OnInit {
  ReportType = ReportType;
  ParentParagraphType = ParentParagraphType;

  @Input({ required: true })
  calculationResults!: CalculationResults;

  @Input({ required: true })
  reportType!: ReportType;

  @Input()
  patientName: string = 'Anonymous';

  retestPeriodMonths = 12;

  currentEthnicity: GraphDataEthnicity = GraphDataEthnicity.WESTERN;

  ngOnInit(): void {
    this.retestPeriodMonths = this.calculationResults.singleMyopeResults?.retestPeriodMonths ?? 12;
  }

  onEthnicityChange(newEthnicity: GraphDataEthnicity): void {
    this.currentEthnicity = newEthnicity;
  }
}
